// Module
var code = "<span> <template v-if=\"type === 'money'\"> {{ getMoney('ru-RU', selectedCurrencyCode, value) }} </template> <template v-else> {{ getNumber('ru-RU', value) }} </template> </span> ";
// Exports
module.exports = code;